import { graphql } from '../gql'

export const AREAS_QUERY = graphql(`
  query Areas {
    areas {
      nodes { id areaName }
    }
  }
`)

export const COUNTRIES_QUERY = graphql(`
  query Countries {
    countries {
      nodes { id countryName countryCode areaId currencyId }
    }
  }
`)

export const CURRENCIES_QUERY = graphql(`
  query Currencies {
    currencies {
      nodes { id currencyName currencyCode }
    }
  }
`)

export const BUSINESS_LINES_QUERY = graphql(`
  query BusinessLines {
    businessLines {
      nodes { id businessLineName }
    }
  }
`)

export const CLUSTERS_QUERY = graphql(`
  query Clusters {
    clusters {
      nodes { id clusterName isWaterFuelTruckApplicable }
    }
  }
`)

export const DETAILED_CLUSTERS_QUERY = graphql(`
  query DetailedClusters {
    detailedClusters {
      nodes { id clusterId detailedClusterName }
    }
  }
`)

export const BRANDS_QUERY = graphql(`
  query Brands {
    brands {
      nodes { id brandName }
    }
  }
`)

export const DEALERS_QUERY = graphql(`
  query Dealers {
    dealers {
      nodes { id dealerName countryId }
    }
  }
`)

export const REGIONS_QUERY = graphql(`
  query Regions {
    regions {
      nodes { id regionName countryId businessLineId }
    }
  }
`)

export const OPERATING_COMPANIES_QUERY = graphql(`
  query OperatingCompanies {
    operatingCompanies {
      nodes { id operatingCompanyName countryId }
    }
  }
`)

export const PLANTS_QUERY = graphql(`
  query Plants {
    plants {
      nodes {
        id plantName plantCode managementCode
        countryId operatingCompanyId
        city zipCode longitude latitude
        ianaTimeZone
      }
    }
  }
`)

export const ASSET_STATUSES_QUERY = graphql(`
  query AssetStatuses {
    assetStatuses {
      nodes { id localizationKey order group }
    }
  }
`)

export const FORMS_OF_FINANCE_QUERY = graphql(`
  query FormsOfFinance {
    formsOfFinance {
      nodes { id localizationKey order }
    }
  }
`)

export const WARRANTIES_QUERY = graphql(`
  query Warranties {
    warranties {
      nodes { id localizationKey order }
    }
  }
`)

export const SERVICE_TYPES_QUERY = graphql(`
  query ServiceTypes {
    serviceTypes {
      nodes { id localizationKey order }
    }
  }
`)

export const SERVICE_PROVIDER_TYPES_QUERY = graphql(`
  query ServiceProviderTypes {
    serviceProviderTypes {
      nodes { id localizationKey order }
    }
  }
`)

export const FINANCING_COMPANIES_QUERY = graphql(`
  query FinancingCompanies {
    financingCompanies {
      nodes { id financingCompanyName countryId }
    }
  }
`)

export const RENTAL_TERMS_QUERY = graphql(`
  query RentalTerms {
    rentalTerms {
      nodes { id localizationKey order }
    }
  }
`)

export const UTILIZATIONS_QUERY = graphql(`
  query Utilizations {
    utilizations {
      nodes { id localizationKey order }
    }
  }
`)

export const TELEMATICS_TYPES_QUERY = graphql(`
  query TelematicsTypes {
    telematicsTypes {
      nodes { id localizationKey order }
    }
  }
`)

export const TELEMATICS_SOURCES_QUERY = graphql(`
  query TelematicsSources {
    telematicsSources {
      nodes { id telematicsSourceDescription }
    }
  }
`)

export const PLAN_ACTION_TYPES_QUERY = graphql(`
  query PlanActionTypes {
    planActionTypes {
      nodes { id localizationKey order }
    }
  }
`)

export const PLAN_PRIORITY_TYPES_QUERY = graphql(`
  query PlanPriorityTypes {
    planPriorityTypes {
      nodes { id localizationKey order }
    }
  }
`)

export const ASSET_HISTORY_TYPES_QUERY = graphql(`
  query AssetHistoryTypes {
    assetHistoryTypes {
      nodes { id localizationKey order assetHistoryTypeDescription }
    }
  }
`)

export const ASSET_IMAGE_TYPES_QUERY = graphql(`
  query AssetImageTypes {
    assetImageTypes {
      nodes { id localizationKey order }
    }
  }
`)

export const DOCUMENT_CATEGORIES_QUERY = graphql(`
  query DocumentCategories {
    documentCategories {
      nodes { id localizationKey order }
    }
  }
`)
